import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  coachingService: service(),
  router: service(),

  model() {
    let individualRecord = this.modelFor(
      'coaching.individuals.individual',
    ).record;
    let lastReport = get(individualRecord, 'sortedReports.lastObject');
    if (get(lastReport, 'completed')) {
      let nextReport = this.coachingService.addReport(individualRecord);
      return nextReport.save().then(() => {
        this.router.transitionTo(
          'coaching.individuals.individual.report.edit',
          get(nextReport, 'id'),
        );
      });
    } else {
      return {
        showNotCompletedErrorMessage: true,
        lastReportId: get(lastReport, 'id'),
      };
    }
  },
});
